import store from '../../../store'

export function createConfigContext (auth, price) {
  return {
    isCustomerList: price.CustomerId > 0,
    isShopList: price.CustomerId === 0 && price.ShopId > 0,
    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
    isCustomerUser: auth.user.UserType === 4,
    isShopUser: auth.user.UserType === 5 || auth.user.UserType === 3 || auth.user.UserType === 7,
    isChainUser: auth.user.UserType === 2,
    isWorkProviderUser: auth.user.UserType === 6,
    isSuperUser: auth.user.UserType === 1,
    department: price.Department,
    useRecommended: price.UseRecommended,
    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
  }
}

export function getEstimationTaskConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationTaskId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: false,
    draggable: true,
    title: null,
    groupCss: 'parts__list1',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'TaskName',
        header: 13348,
        type: 'text',
        editable: false,
        hide: false,
        css: 'name'
      }
    ],
    newItemInputs: ['TaskName'],
    groupField: 'PartItemId'
  }
}

export function getEstimationExtraConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationExtraId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: false,
    draggable: true,
    title: null,
    groupCss: 'parts__list2',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Name',
        header: 13374,
        type: 'text',
        editable: false,
        hide: false,
        css: 'name',
        col: 3
      },
      {
        name: 'AE',
        header: 885,
        type: 'ae',
        editable: true,
        hide: false,
        css: 'ae'
      },
      {
        name: 'Material',
        header: 13443,
        type: 'currency',
        editable: true,
        hide: false,
        css: 'mat'
      }
    ],
    newItemInputs: ['Name', 'AE', 'Material'],
    groupField: 'PartItemId'
  }
}

export function getStartTimeConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationStartTimeId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: true,
    draggable: true,
    title: 1195,
    groupCss: 'starttime__list',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Type',
        header: 332,
        type: 'text',
        editable: false,
        hide: false,
        css: 'type',
        col: 2
      },
      {
        name: 'Ae',
        header: 885,
        type: 'ae',
        editable: false,
        hide: false,
        css: 'ae'
      }
    ],
    newItemInputs: ['Type', 'AE']
  }
}

export function getRefinishTypeConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationRefinishTypeId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: true,
    draggable: context.isChainList,
    title: 1999,
    groupCss: 'refinishtype__list',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Type',
        type: 'text',
        editable: false,
        hide: false,
        css: 'type'
      }
    ],
    newItemInputs: ['Type']
  }
}

export function getHourPriceConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationHourPriceId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: true,
    draggable: context.isChainList,
    title: 1847,
    groupCss: 'hourprices__list',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Price',
        type: 'int',
        editable: false,
        hide: false,
        css: 'price'
      }
    ],
    newItemInputs: ['Price']
  }
}

export function getMaterialsShareConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'EstimationMaterialsShareId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: true,
    draggable: true,
    title: 13483,
    groupCss: 'materialsshare__list',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Share',
        type: 'int',
        editable: false,
        hide: false,
        css: 'share'
      }
    ],
    newItemInputs: ['Share']
  }
}

export function getExtentConfig (context) {
  const state = store.getState()
  const editable = (!context.isCustomerUser && !context.useRecommended) &&
                   (state.common.activeCustomer.IsPerformingCustomer !== true)
  return {
    itemIdField: 'PriceModelExtentId',
    itemOrderField: 'SortIndex',
    editable: editable,
    whitebox: true,
    draggable: true,
    title: 2093,
    groupCss: 'extent__list',
    itemCss: '',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Type',
        header: 332,
        type: 'text',
        editable: false,
        hide: false,
        css: 'type',
        col: 2
      },
      {
        name: 'Group',
        header: 13446,
        type: 'select',
        options: [{1: '1'}, {2: '2'}, {3: '3'}, {4: '4'}, {5: '5'}],
        editable: false,
        hide: false,
        css: 'group'
      }
    ],
    newItemInputs: ['Type', 'Group']
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Estimation/config.js